import { BankAccountLocation } from '@40seas/entities/bank-account';
import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const CardPaymentMethodSchema = z.object({
    brand: z.string(),
    last4: z.string(),
    funding: z.string().optional(),
    fingerPrint: z.string().optional(),
    country: z.string().optional(),
    expMonth: z.number().optional(),
    expYear: z.number().optional(),
    cardholderName: z.string().optional(),
    location: EnumSchema(BankAccountLocation).optional(),
});

export class CardPaymentMethod extends FromSchema(CardPaymentMethodSchema) {
    brand: string;
    last4: string;
    fingerPrint?: string;
    expMonth?: number;
    expYear?: number;
    funding?: string;
    country?: string;
    cardholderName?: string;
    location?: BankAccountLocation;
}
